import { render, staticRenderFns } from "./ImportBarang.vue?vue&type=template&id=0149d6b2"
import script from "./ImportBarang.vue?vue&type=script&lang=js"
export * from "./ImportBarang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports